import { Meta } from "entities/common";
import {
  AddUserRequest,
  CompanyItem,
  CompanyListStatistics,
  CompanyStatistics,
  CreateCompanyRequest,
  EmirateCityListResponse,
  GeoCityListResponse,
  GeoCountryListResponse,
  UpdateCompanyRequest,
  UserItem,
} from "entities/companies";
import { DELETE, GET, PATCH, POST } from "utils/http";

const baseUrl = "/api";

// side logic
export const getCompanyListStatistics = () => GET<CompanyListStatistics>(`${baseUrl}/statistics/companies`);

export const getCompanyStatistics = (company_id: number) =>
  GET<CompanyStatistics>(`${baseUrl}/statistics/companies/${company_id}/dashboard`);

export const getCountries = (search?: string) =>
  GET<GeoCountryListResponse>(`${baseUrl}/countries`, {
    params: search ? { search } : undefined,
  });

export const getCities = (params: { country_id?: number; search?: string; page?: number; page_size?: number }) =>
  GET<GeoCityListResponse>(`${baseUrl}/cities`, { params });

export const getEmirateCities = (params: { company_id: number; search?: string }) =>
  GET<EmirateCityListResponse>(`${baseUrl}/emirate-cities`, { params });

// company logic
export const getList = (query = "") => GET<{ items: CompanyItem[] } & Meta>(`${baseUrl}/companies${query}`);

export const getCompany = (id: number) => GET(`${baseUrl}/companies/${id}`);

export const create = (body: CreateCompanyRequest) => POST(`${baseUrl}/companies`, body);

export const update = ({ id, body }: { id: number; body: UpdateCompanyRequest }) =>
  PATCH(`${baseUrl}/companies/${id}`, body);

export const remove = (id: number) => DELETE(`${baseUrl}/companies/${id}`);

// company user logic
export const getCompanyUsers = ({ companyId, query = "" }: { companyId: number; query?: string }) =>
  GET<{ items: UserItem[] } & Meta>(`${baseUrl}/companies/${companyId}/users${query}`);

export const addUser = (data: { companyId: number; body: AddUserRequest }) =>
  POST(`${baseUrl}/companies/${data.companyId}/users`, data.body);

export const updateUser = (data: { companyId: number; userId: number; body: AddUserRequest }) =>
  PATCH(`${baseUrl}/companies/${data.companyId}/users/${data.userId}`, data.body);

export const removeUser = (data: { companyId: number; userId: number }) =>
  DELETE(`${baseUrl}/companies/${data.companyId}/users/${data.userId}`);

export const resendUserInvitation = (data: { companyId: number; userId: number }) =>
  POST(`${baseUrl}/companies/${data.companyId}/users/${data.userId}/resend-invitation`);
